import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React from "react"
import styles from "./styles"
import { View } from "react-native"
import { baseColors } from "@Constants/baseStyles"
import ProgressCircle from "@Components/PercentageCircle"

export const RestultStatistic = (props) => {
    const { isResult, questionLength, correctQuizzLength, fetchingResponse } = props
    const percentage = 100

    return (
        <View>
            {isResult && !fetchingResponse && (
                <View>
                    <BreeSerifText style={{ marginBottom: 15 }} fontSize={18} color={baseColors.green.primary}>
                        Résultat du quiz
                    </BreeSerifText>
                    <OpenSansText style={{ marginBottom: 25 }} fontSize={15} color={baseColors.black}>
                        Vous avez bien répondu à la moitié des questions, vous avez encore des choses à apprendre !
                    </OpenSansText>

                    {/* <View style={styles.chartContainer}>
                        <ProgressCircle
                            percent={percentage}
                            radius={40}
                            borderWidth={7}
                            color={baseColors.green.dark}
                            shadowColor={baseColors.green.light}
                            bgColor="white"
                        >
                            <OpenSansText style={{ color: baseColors.green.primary, fontSize: 20 }}>
                                {questionLength} / {questionLength}
                            </OpenSansText>
                        </ProgressCircle>
                    </View> */}
                </View>
            )}
        </View>
    )
}
